import type { LanguageKey } from "@packages/core/language/language.ts";
import { createI18nextInstance as createInstance } from "@packages/core-client/i18n/createI18nextInstance.ts";
import type { FireflyRuntime } from "@squide/firefly";
import { getI18nextPlugin, type i18nextPlugin } from "@squide/i18next";
import { en } from "./en.ts";
import { fr } from "./fr.ts";

export const meetingsI18NextInstanceKey = "meetings-domain";

export function initMeetingsI18next(runtime: FireflyRuntime) {
    const i18nextPlugin = getI18nextPlugin(runtime) as i18nextPlugin<LanguageKey>;

    try {
        return i18nextPlugin.getInstance(meetingsI18NextInstanceKey);
    } catch {}

    const instance = createInstance(i18nextPlugin.currentLanguage, {
        resources: { en, fr }
    });

    i18nextPlugin.registerInstance(meetingsI18NextInstanceKey, instance);

    return instance;
}
